<div class="detail-page-card">
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="reloadSiteConfigurations()">
            <i class="fas fa-sync"></i>
            <span class="d-none d-lg-inline">Reload Site Configurations</span>
        </button>
    </div>
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="reloadDbSettings()">
            <i class="fas fa-database"></i>
            <span class="d-none d-lg-inline">Reload DB Settings</span>
        </button>
    </div>
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="triggerNotifications()">
            <i class="fas fa-mail-bulk"></i>
            <span class="d-none d-lg-inline">Trigger Notifications</span>
        </button>
    </div>
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="testScheduler()">
            <i class="fas fa-check"></i>
            <span class="d-none d-lg-inline">Test Scheduler</span>
        </button>
    </div>
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="clearFluentIconsCache()">
            <i class="fas fa-trash"></i>
            <span class="d-none d-lg-inline">Clear Fluent Icons Cache</span>
        </button>
    </div>
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="controlExecutionGenerateSourceDocs()">
            <i class="fad fa-spinner-third"></i>
            <span class="d-none d-lg-inline"
                >Generate Source Documents for Control Execution Testplans</span
            >
        </button>
    </div>
    <div class="detail-page-card-actions">
        <button class="btn btn-raised" (click)="migrateToIncidents()">
            <i class="fad fa-suitcase-rolling"></i>
            <span class="d-none d-lg-inline">Migrate to incidents</span>
        </button>
    </div>
</div>
